export default {
  updateCaslRules (state, newRules) {
    let mergedRules = []
    Object.assign(mergedRules, state.caslRules, newRules)
    state.caslRules = mergedRules
  },
  destroyCasl (state) {
    state.caslRules = []
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/casl.js